import React, { Fragment, useEffect, useState } from 'react';
import {
	Checkbox,
	Collapse,
	Divider,
	Form,
	Image,
	Input,
	Popconfirm,
	Radio,
	Select,
	Slider,
	Space,
	Upload,
} from 'antd';
import {
	AlignCenterOutlined,
	AlignLeftOutlined,
	AlignRightOutlined,
	CloseCircleOutlined,
	LoadingOutlined,
	PlusOutlined,
} from '@ant-design/icons';
import { API_BASE_URL, ASSET_BASE_URL } from '../../../configs/AppConfig';
import { SketchPicker } from 'react-color';
import _ from 'lodash';

import * as sass from 'sass';

//[LANG]
export function applyLang(object, lang) {
    if (!lang || !object[lang.value]) {
        return object
    }

    let dataLang = object[lang.value]
    let dataMerge = {}
    for (let k of Object.keys(dataLang)) {
        const finalValue = checkValue(dataLang[k])
        if (finalValue) {
            dataMerge[k] = finalValue
        }
    }

    return _.merge(object, dataMerge)
}

function checkValue(value) {
    if (typeof value === "object") {
        let object = {}
        for (let k of Object.keys(value)) {
            const v = checkValue(value[k])
            if (v) {
                object[k] = v
            }
        }
        return object
    }

    if (Array.isArray(value)) {
        const array = []
        for (let item of value) {
            const sub = checkValue(item)
            if (sub) {
                array.push(sub)
            }
        }
        return array
    }

    if (typeof value === "string") {
        value = value.trim()
    }

    if (value) {
        return value
    }

    return null
}

//[LANG]

export function injectLayoutParams(plugins) {
    return plugins.map(p => {
        if (p.injectedLayoutParams || p.ignoreLayoutParams) {
            return p
        }

        const renderer = p.Renderer
        p.Renderer = hookRenderer(renderer)
        p.controls = hookControls(p)

        p.injectedLayoutParams = true
        return p
    })
}


//RENDER

function hookRenderer(renderer) {
    return (props) => {
        //console.log(props)
        const data = checkStyleValues(props.data)
        //console.log(data)

        var containerStyle = {}
        var backgroundStyle = {width: "100%"}
        var filterStyle = {width: "100%"}
        var elementContainerStyle = {width: "100%"}
        var elementStyle = {}


        containerStyle = renderPadding(data, containerStyle)

        backgroundStyle = renderBackgroundContainer(data, backgroundStyle)

        filterStyle = renderBackgroundLight(data, filterStyle)

        elementContainerStyle = renderBackgroundAlign(data, elementContainerStyle)

        elementStyle = renderSize(data, elementStyle)

        if (!props.isEditMode) {
            elementStyle = renderOverflow(data, elementStyle)
        }


        //console.log(elementStyle)
        //console.log(subElementStyle)

        const layoutId = "layout-" + props.nodeId
        const backgroundlayoutId = "bg-layout-" + props.nodeId
        let css = ``

        if (data._color && data._color !== "transparent") {
            css += "#" + layoutId + " * {color:" + data._color + " !important;}\n"
        }

        if (data._formLabelColor && data._formLabelColor !== "transparent") {
            css += "#" + layoutId + " .ant-form-item-label>label{color:" + data._formLabelColor + " !important;}\n"
            css += "#" + layoutId + " .layout-label{color:" + data._formLabelColor + " !important;}\n"
        }

        if (data["_background-custom-css"]) {
            let _scss = "#" + backgroundlayoutId + "{" + data["_background-custom-css"] + "}"
            const result = sass.compileString(_scss, {style: 'compressed'})
            const _css = result.css.toString() + "\n"
            //console.log(_css)
            css += _css
        }

        let hiddenStyle={}
        if(data["_hidden-module"]){
            hiddenStyle={opacity:0.5,border:"1px dashed #000"}

            if(props.isPreviewMode){
                hiddenStyle={display:"none"}
            }
        }

        //console.log(css)

        return (
            <div style={hiddenStyle}>
                <style>{css}</style>
                <div id={backgroundlayoutId} style={backgroundStyle}>
                    <div id={layoutId} style={containerStyle}>

                        <div style={filterStyle}>

                            <div style={elementContainerStyle}>
                                <div style={elementStyle}>
                                    {renderer(props)}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function hookStyleValue(value, indicator = "px") {
    if (/^\d+$/.test(value)) {
        return value + indicator
    }
    return value
}

function checkStyleValues(values) {
    var allValues = values
    Object.keys(allValues).forEach(k => {
        if (typeof allValues[k] === "string") {
            if (!allValues[k] || allValues[k].trim() === "") {
                allValues[k] = null
            }
        }
    })

    return allValues
}

function renderSize(data, style) {
    style = {
        ...style, ...{
            width: "100%",
            minWidth: "auto",
            maxWidth: "auto",

            height: "auto",
            minHeight: "auto",
            maxHeight: "auto",
        }
    }

    if (data["_height"]) {
        style.height = hookStyleValue(data["_height"])
    }

    if (data["_min-height"]) {
        style.minHeight = hookStyleValue(data["_min-height"])
    }

    if (data["_max-height"]) {
        style.maxHeight = hookStyleValue(data["_max-height"])
    }


    if (data["_width"]) {
        style.width = hookStyleValue(data["_width"], "%")
    }

    if (data["_min-height"]) {
        style.minWidth = hookStyleValue(data["_min-width"], "%")
    }

    if (data["_max-width"]) {
        style.maxWidth = hookStyleValue(data["_max-width"], "%")
    }

    return style
}

function renderOverflow(data, style) {
    style = {...style, ...{overflow: "initial"}}

    if (data["_overflow"]) {
        style.overflow = data["_overflow"]
    }

    return style
}

function renderPadding(data, style) {
    style = {...style, ...{paddingTop: 0, paddingBottom: 0, paddingRight: 0, paddingLeft: 0}}

    if (data["_padding-top"]) {
        style.paddingTop = hookStyleValue(data["_padding-top"])
    } else if (data["_padding"]) {
        style.paddingTop = hookStyleValue(data["_padding"])
    }

    if (data["_padding-bottom"]) {
        style.paddingBottom = hookStyleValue(data["_padding-bottom"])
    } else if (data["_padding"]) {
        style.paddingBottom = hookStyleValue(data["_padding"])
    }

    if (data["_padding-left"]) {
        style.paddingLeft = hookStyleValue(data["_padding-left"])
    } else if (data["_padding"]) {
        style.paddingLeft = hookStyleValue(data["_padding"])
    }

    if (data["_padding-right"]) {
        style.paddingRight = hookStyleValue(data["_padding-right"])
    } else if (data["_padding"]) {
        style.paddingRight = hookStyleValue(data["_padding"])
    }

    return style
}

function renderBackgroundContainer(data, style) {
    style = {
        ...style, ...{
            borderRadius: "0",
            backgroundColor: "transparent",
            backgroundImage: null,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center"
        }
    }

    if (data["_border-radius"]) {
        style.borderRadius = hookStyleValue(data["_border-radius"])
    }

    if (data["_background-color"]) {
        style.backgroundColor = data["_background-color"]
    }

    if (data["_background-image"]) {
        style.backgroundImage = "url('" + data["_background-image"] + "')"
    }

    if (data["_background-size"]) {
        style.backgroundSize = data["_background-size"]
    }

    if (data["_background-position"]) {
        style.backgroundPosition = data["_background-position"]
    }

    //console.log(data,style)

    return style
}

function renderBackgroundAlign(data, style) {
    style = {
        ...style, ...{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }
    }


    if (data["_element-align"]) {
        style.justifyContent = data["_element-align"]
    }

    return style
}

function renderBackgroundLight(data, style) {
    var darken = 0
    var lighten = 0

    if (data["_background-darken"]) {
        darken = data["_background-darken"] / 100
    }

    if (data["_background-lighten"]) {
        lighten = data["_background-lighten"] / 100
    }

    return {...style, ...{backgroundImage: `linear-gradient(rgba(0, 0, 0, ${darken}), rgba(0, 0, 0, ${darken})),linear-gradient(rgba(255, 255, 255, ${lighten}), rgba(255, 255, 255, ${lighten}))`}}
}

//CONTROLS

function hookControls(plugin) {
    var controls = []
    if (Array.isArray(plugin.controls)) {
        controls = controls.concat(plugin.controls)

    } else if (plugin.controls) {
        controls.push({title: plugin.title, controls: plugin.controls})
    }

    controls.push({
        title: "General", controls: {
            type: "custom", Component: (props) => {
                return <LayoutControls {...props}/>
            }
        }
    })

    //console.log(controls)
    if (controls.length === 1) {
        return controls[0].controls
    }

    return controls
}

function LayoutControls(props) {
    const [show, setShow] = useState(true)
    const refreshForm = () => {
        setShow(false)
        setTimeout(() => setShow(true), 500)
    }

    useEffect(() => {
        refreshForm()
    }, [props.lang, props.nodeId, props.device])

    if (!show) {
        return null
    }

    const initialValues = {
        ...{
            "_background-size": "cover",
            "_background-position": "center",
            "_overflow": "initial"
        }, ...props.data
    }

    return (
        <Form
            size={"small"}
            layout={"vertical"}
            initialValues={initialValues}
            onValuesChange={(_, allValues) => props.onChange(allValues)}
        >

            <Form.Item name={"_hidden-module"} valuePropName={"checked"}>
                <Checkbox>Masquer le module</Checkbox>
            </Form.Item>

            <Collapse defaultActiveKey={[0, 1, 2]}>

                <Collapse.Panel key={0} header={"Taille"}>
                    <SizeControls {...props}/>
                </Collapse.Panel>

                <Collapse.Panel key={1} header={"Marges"}>
                    <PaddingControls {...props}/>
                </Collapse.Panel>


                <Collapse.Panel key={2} header={"Arriere Plan"}>
                    <BackgroundControls {...props}/>
                </Collapse.Panel>
            </Collapse>

        </Form>
    )
}

function SizeControls(props) {
    return (
        <>
            <Divider>Hauteur</Divider>

            <Form.Item label={"Hauteur"} name={"_height"}>
                <Input placeholder={"Hauteur"} style={{width: "100%"}}/>
            </Form.Item>

            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <Form.Item label={"Hauteur Minimal"} name={"_min-height"}>
                    <Input placeholder={"Hauteur Minimal"} style={{width: 140}}/>
                </Form.Item>

                <Form.Item label={"Hauteur Maximal"} name={"_max-height"}>
                    <Input placeholder={"Hauteur Maximal"} style={{width: 140}}/>
                </Form.Item>
            </div>

            <Divider>Largeur</Divider>

            <Form.Item label={"Largeur"} name={"_width"}>
                <Input placeholder={"Largeur"} style={{width: "100%"}}/>
            </Form.Item>

            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <Form.Item label={"Largeur Minimal"} name={"_min-width"}>
                    <Input placeholder={"Largeur Minimal"} style={{width: 140}}/>
                </Form.Item>

                <Form.Item label={"Largeur Maximal"} name={"_max-width"}>
                    <Input placeholder={"Largeur Maximal"} style={{width: 140}}/>
                </Form.Item>
            </div>


            <Divider>Dépassement & Alignement</Divider>

            <Form.Item label={"Dépassement"} name={"_overflow"}>
                <Select>
                    <Select.Option value={"initial"}>Ignoré</Select.Option>
                    <Select.Option value={"hidden"}>Masqué</Select.Option>
                    <Select.Option value={"scroll"}>faire défiler</Select.Option>
                </Select>
            </Form.Item>


            <Form.Item label={"Alignement"} name={"_element-align"}>
                <Radio.Group size={"large"} options={[
                    {label: <AlignLeftOutlined/>, value: "flex-start"},
                    {label: <AlignCenterOutlined/>, value: "center"},
                    {label: <AlignRightOutlined/>, value: "flex-end"},
                ]} optionType="button"/>
            </Form.Item>
        </>
    )
}

function PaddingControls(props) {
    return (
        <>
            <Form.Item label={"Marge Globale"} name={"_padding"}>
                <Input placeholder={"Marge Globale"} style={{width: "100%"}}/>
            </Form.Item>
            <Divider>Marge Détaillé</Divider>

            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <Form.Item label={"Marge Haut"} name={"_padding-top"}>
                    <Input placeholder={"Marge Haut"} style={{width: 140}}/>
                </Form.Item>

                <Form.Item label={"Marge Bas"} name={"_padding-bottom"}>
                    <Input placeholder={"Marge Bas"} style={{width: 140}}/>
                </Form.Item>
            </div>

            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <Form.Item label={"Marge Gauche"} name={"_padding-left"}>
                    <Input placeholder={"Marge Gauche"} style={{width: 140}}/>
                </Form.Item>

                <Form.Item label={"Marge Droite"} name={"_padding-right"} style={{width: 140}}>
                    <Input placeholder={"Marge Droite"}/>
                </Form.Item>
            </div>
        </>
    )
}

function BackgroundControls(props) {
    return (
        <>
            <Form.Item label={"Couleur des libellés"} name={"_formLabelColor"}>
                <ColorPicker/>
            </Form.Item>

            <Form.Item label={"Couleur du texte"} name={"_color"}>
                <ColorPicker/>
            </Form.Item>

            <Form.Item label={"Couleur de fond"} name={"_background-color"}>
                <ColorPicker/>
            </Form.Item>

            <Form.Item label={"Arrondie"} name={"_border-radius"}>
                <Input placeholder={"Arrondie"} style={{width: 140}}/>
            </Form.Item>

            <Form.Item label={"Image de fond"} name={"_background-image"}>
                <UploadImage/>
            </Form.Item>

            <Form.Item label={"Taille image de fond"} name={"_background-size"}>
                <Select>
                    <Select.Option value={"cover"}>Taille du Block</Select.Option>
                    <Select.Option value={"contain"}>Taille de l'image</Select.Option>
                </Select>
            </Form.Item>

            <Form.Item label={"Positionnement image de fond"} name={"_background-position"}>
                <Select>
                    <Select.Option value={"center"}>Centré</Select.Option>
                    <Select.Option value={"top"}>Haut</Select.Option>
                    <Select.Option value={"bottom"}>Bas</Select.Option>
                    <Select.Option value={"left"}>Gauche</Select.Option>
                    <Select.Option value={"right"}>Droite</Select.Option>
                </Select>
            </Form.Item>


            <Form.Item label={"Éclairage"} name={"_background-lighten"}>
                <Slider tipFormatter={(tip) => tip + "%"} min={0} max={100}/>
            </Form.Item>

            <Form.Item label={"Assombrir"} name={"_background-darken"}>
                <Slider tipFormatter={(tip) => tip + "%"} min={0} max={100}/>
            </Form.Item>


            <Form.Item label={"Style personnalisé"} name={"_background-custom-css"}>
                <Input.TextArea style={{minHeight: 150}} allowClear={true}/>
            </Form.Item>
        </>
    )
}

function UploadImage(props) {
    const [loading, setLoading] = useState(false);

    const uploadButton = (
        <div>
            {loading ? <LoadingOutlined/> : <PlusOutlined/>}
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Télécharger une image
            </div>
        </div>
    );


    return (
        <Space align={"start"}>
            <Upload
                disabled={props.value}
                accept="image/*"
                name="avatar"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                headers={{authorization: localStorage.getItem("AUTH_TOKEN")}}
                action={API_BASE_URL + "/upload/image?autoValide=1"}
                onChange={({file}) => {
                    setLoading(file.percent < 0)

                    if (file.response && file.status === "done") {
                        const url = ASSET_BASE_URL + "/" + file.response
                        props.onChange(url)
                    }
                }}
            >
                {props.value && props.value !== "" ? (
                    <Image
                        src={props.value}
                        alt="avatar"
                        style={{
                            width: '100%',
                        }}
                    />
                ) : (
                    uploadButton
                )}
            </Upload>

            {props.value && (
                <CloseCircleOutlined style={{cursor: 'pointer',}} onClick={() => props.onChange("")}/>
            )}
        </Space>
    )
}

class ColorPicker extends React.Component {

    state = {
        show: false
    }

    render() {
        //console.log(this.props)

        if (!this.props.value) {
            this.props.onChange("transparent")
        }

        let Component = <SketchPicker color={this.props.value}
                                      onChange={(color, event) => this.props.onChange(color.hex)}/>

        let background = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16  ' viewBox='0 0 8 8'%3E%3Cg fill='%23c5c5c5' fill-opacity='0.4'%3E%3Cpath fill-rule='evenodd' d='M0 0h4v4H0V0zm4 4h4v4H4V4z'/%3E%3C/g%3E%3C/svg%3E\")"
        if (this.props.value !== "transparent") {
            background = this.props.value
        }

        return (
            <Space>
                <Popconfirm showCancel={false} showArrow={false} icon={null} okButtonProps={{style: {display: "none"}}}
                            title={Component}>
                    <div style={{
                        padding: '5px',
                        background: '#fff',
                        borderRadius: '5px',
                        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                        display: 'inline-block',
                        cursor: 'pointer',
                    }} onClick={() => this.setState({show: true})}>
                        <div style={{
                            width: '36px',
                            height: '14px',
                            borderRadius: '2px',
                            background: background,
                        }}/>
                    </div>
                </Popconfirm>
                <CloseCircleOutlined style={{cursor: 'pointer',}} onClick={() => this.props.onChange("transparent")}/>
            </Space>
        )

    }

}
